import { render, staticRenderFns } from "./CreateTicketItem.vue?vue&type=template&id=1e03baa5&"
import script from "./CreateTicketItem.vue?vue&type=script&lang=js&"
export * from "./CreateTicketItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports